<template>
    <div>
        <div class="propertyImagesRef">
            <div class="drop-area" v-if="maxFiles == 0 || maxFiles > propertyImages.length">
                <div class="p-5">
                    <h4>Drop files here to upload<br/>or</h4>
                    <label for="file" class="btn btn-lg btn-primary">Select Files</label>
                </div>
            </div>
            <div v-if="propertyImagesReader.length" class="multifileContainer">
                <template v-if="showPreviews">
                    <div class="col-4" v-for="(file, idx) in propertyImagesReader" :key="file.id">
                        <div class="custom-file-input logo" >
                            <img :src="propertyImagesReader[idx]" alt="" class="upload-img" :class="{checkerboard: showCheckerboard}">
                            <div class="overlay-remove">
                                <a href="#" class="no-underline" @click.prevent="removeImage(idx)">Remove</a>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <ul v-if="propertyImages.length">
                        <li v-for="file in propertyImages" :key="file.id">
                            <span>{{file.name}}</span> -
                            <span>{{(file.size)}}</span> -
                            <span v-if="file.error">{{file.error}}</span>
                            <span v-else-if="file.success">success</span>
                            <span v-else-if="file.active">active</span>
                            <span v-else></span>
                        </li>
                    </ul>
                </template>
            </div>
        </div>

        <vue-upload-component
            ref="propertyImagesRef"
            :value="propertyImages"
            :extensions="acceptedFileExtensions"
            :multiple="true"
            :drop="true"
            @input="inputUpdate"
            @input-file="inputFile"
            :maximum="maxFiles"
            :size="maxFileSize"
            ></vue-upload-component>
    </div>
</template>

<script>
import VueUploadComponent from 'vue-upload-component'

export default {
    components: {
        VueUploadComponent
    },
    props: {
        maxFileSize: {
            type: Number,
            default: 1024 * 1024
        },
        maxFiles: {
            type: Number,
            default: 4
        },
        acceptedFileExtensions: {
            type: String,
            default: "gif,jpg,jpeg,png,webp"
        },
        showPreviews: {
            type: Boolean,
            default: true
        },
        showCheckerboard: {
            default: true,
            type: Boolean
        }
    },
    data() {
        return {
            propertyImages: [],
            propertyImagesReader: []
        }
    },
    methods: {
        inputUpdate(files) {
            this.propertyImages = files;
            this.$emit('fileupload', this.propertyImages);
        },
        inputFile: function (newFile, oldFile) {
            // New File added
            if(newFile && !oldFile) {
                this.getImagePreview(newFile.file);
            }
        },
        getImagePreview (file) {
            let reader = new FileReader();
            reader.addEventListener("load", function() {
                this.propertyImagesReader.push(reader.result);
            }.bind(this), false);
            if (file) {
                if (/\.(jpe?g|png|gif|svg)$/i.test(file.name)) {
                    reader.readAsDataURL(file);
                }
            }
        },
        removeImage(index) {
            this.propertyImagesReader.splice(index, 1);
            this.propertyImages.splice(index, 1);
        }
    }
}

</script>
